export default __webpack_public_path__ + "static/media/evo_banner.9aadd8fa.png";